/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class BookingApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `BookingModule.forRoot()`
 */
export interface BookingApiConfigurationParams {
  rootUrl?: string;
}
